var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full px-4",attrs:{"id":"backState"}},[_c('div',{staticClass:"max-w-lg mx-auto"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('goBack')}}},[_vm._v(" ← Back ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }